import { EventEmitter } from "@angular/core";

export class InputUtils {
    static updated: EventEmitter<HTMLInputElement> = new EventEmitter<HTMLInputElement>();

    public static onInput($event: any, normalize: "alfa" | "numeric" | "alfanum" | "email") {
        let regex = null;

        if (!$event.target.value) return;

        switch (normalize) {
            case "alfa":
                regex = /[^A-zÀ-ú ]/gi;
                break;
            case "alfanum":
                regex = /[^A-zÀ-ú0-9 ]/gi;
                break;
            case "numeric":
                regex = /[^0-9]*$/gi;
                break;
            case "email":
                regex = /[^a-zà-ú@.^0-9]/gi;
                break;
        }

        if (regex) $event.target.value = $event.target.value.replace(regex, "");

        $event.currentTarget.value = $event.target.value;
        InputUtils.updated.next($event.target);
    }
}